import ApiUrlCreatorService from "@core-ui/ContextServices/ApiUrlCreator";
import ArticlePropsService from "@core-ui/ContextServices/ArticleProps";
import ArticleRefService from "@core-ui/ContextServices/ArticleRef";
import IsMacService from "@core-ui/ContextServices/IsMac";
import PageDataContextService from "@core-ui/ContextServices/PageDataContext";
import PlatformService from "@core-ui/ContextServices/PlatformService";
import ResourceService from "@core-ui/ContextServices/ResourceService/ResourceService";
import { useResourceStoreContext } from "@core-ui/ContextServices/ResourceService/store/ResourceStore.provider";
import SourceDataService from "@core-ui/ContextServices/SourceDataService";
import { useCatalogPropsStore } from "@core-ui/stores/CatalogPropsStore/CatalogPropsStore.provider";
import { type EditorContextValue, setEditorContext } from "@ext/markdown/elementsUtils/editorContext/EditorContext";
import { useSetting } from "@ext/settings/logic/hooks";
import type { Editor } from "@tiptap/core";
import { useLayoutEffect } from "react";

export type EditorContextOverride = Partial<Pick<EditorContextValue, "noWrite">>;

const useEditorContext = (editor: Editor | null, override?: EditorContextOverride): void => {
	const [theme] = useSetting("general.theme");
	const isMac = IsMacService.value;
	const articleProps = ArticlePropsService.value;
	const catalogProps = useCatalogPropsStore((state) => state.data);
	const apiUrlCreator = ApiUrlCreatorService.value;
	const pageDataContext = PageDataContextService.value;
	const articleRef = ArticleRefService.value;
	const resourceService = ResourceService.value;
	const resourceStore = useResourceStoreContext();
	const noWrite = override?.noWrite ?? false;
	const platform = PlatformService.value;
	const sourceData = SourceDataService.value;

	// biome-ignore lint/correctness/useExhaustiveDependencies: expected
	useLayoutEffect(() => {
		setEditorContext(editor, {
			theme,
			isMac,
			articleProps,
			catalogProps,
			apiUrlCreator,
			pageDataContext,
			articleRef,
			resourceService,
			resourceStore,
			platform,
			sourceData,
			noWrite,
		});
	}, [
		editor,
		theme,
		isMac,
		articleProps,
		catalogProps,
		apiUrlCreator,
		pageDataContext,
		articleRef,
		resourceService,
		resourceStore,
		platform,
		sourceData,
		noWrite,
	]);
};

export default useEditorContext;
